import React, { useEffect, useState } from "react";
import moment from "moment";
import Dropdown from "../../../../components/DropDown";
import Button from "../../../../components/Button";
import PermissionUtils from "../../../../core/store/utils/PermissionUtils";
import { fetchAvailableBedSlots } from "../../../../core/services/api/bedManagementService";
import "./AllocationRequestCard.scss";
import { useHistory } from "react-router";

export default function AllocationRequestCard({
  userRole, eachAppointment, allRooms, onBedBook
}: any) {

  const [availableSlots, updateAvailableSlots] = useState<any>([])

  const [selectedRoom, updateSelectedRoom] = useState<any>()
  const [selectedBed, updateSelectedBed] = useState<any>()

  const [selectedSlots, updateSelectedSlots] = useState<any>([])
  const [enableSlots, disablelots] = useState<any>();

  const [preferredRoomName, updatePreferredRoomName] = useState<any>();
  const [preferredBedName, updatePreferredBedName] = useState<any>();
  const location = useHistory();

  const params = new URLSearchParams(window.location.search)
  const token = params.get("appointmentId")



  console.log(token, "appId")

  useEffect(() => {
    if (allRooms?.length > 0 && eachAppointment?.bedPreference) {
      let tempRoom = allRooms.find((each: any) => each?.id == eachAppointment?.bedPreference?.roomId)
      updateSelectedRoom(tempRoom)
      updateSelectedBed(eachAppointment?.bedPreference?.bedId)
      updatePreferredRoomName(tempRoom?.name)
      let tempBed = tempRoom?.bedDetails?.find((each: any) => each?.id == eachAppointment?.bedPreference?.bedId)
      updatePreferredBedName(tempBed?.name)
    }
  }, [allRooms, eachAppointment?.bedPreference])

  function checkAvailability() {
    let bedId = selectedBed
      ? selectedBed
      : selectedRoom?.bedDetails[0]?.id
    fetchAvailableBedSlots(
      selectedRoom?.id,
      eachAppointment?.scheduleDate,
      bedId
    )
      .then((res: any) => {
        let tempRes = [...res];
        if (eachAppointment?.scheduleDate === moment().local().format("yyyy-MM-DD")) {
          var currentTime = moment().format("HH:mm");
          const temp = res?.filter((eachItem: any) => eachItem > currentTime)
          tempRes = [...temp];
          console.log(temp, "temp")

        }
        console.log('eachAppointment?.allottedBed', eachAppointment?.allottedBed)
        if (eachAppointment?.allottedBed && eachAppointment?.allottedBed?.slots?.length > 0) {
          let first = eachAppointment?.allottedBed?.slots[0]
          console.log("first", first)
          var firstTimeMoment = moment(first, "HH:mm").format("HH:mm");
          console.log("firstTimeMoment", firstTimeMoment)
          const tempOfFirst = res?.filter((eachItem: any) => eachItem > first)
          console.log("tempOfFirst", tempOfFirst)
          tempRes = [...tempOfFirst];
        }
        console.log('tempRes', tempRes)
        updateAvailableSlots([...tempRes])
      })
      .catch((Err) => console.log("Err in available bed slot fetch", Err))
  }

  function onRoomSelect(options: any) {
    const temp = allRooms?.find((each: any) => each?.id === options)
    updateSelectedRoom(temp)

    if (temp?.bedDetails?.length > 0)
      onBedSelect(temp?.bedDetails[0]?.id)
    else onBedSelect("")
  }


  function onBedSelect(options: any) {
    updateSelectedBed(options)
  }

  console.log(availableSlots, "availableSlots")

  function renderSlots(eachSlot: any) {
    const isActive = selectedSlots?.includes(eachSlot)

    return (
      <div
        className="timeSlot"
        style={{
          backgroundColor: isActive ? "#024cf2" : "white",
          color: isActive ? "white" : "black",
        }}
        onClick={() => {
          const temp = [...selectedSlots]
          if (temp) {
            if (temp?.includes(eachSlot)) {
              temp.splice(temp.indexOf(eachSlot), 1)
            } else {
              temp.push(eachSlot)
            }
            updateSelectedSlots(temp)
            console.log(temp?.length, "temppp")
            disablelots(temp)
          }
        }}
      >
        {moment(eachSlot, "HH:mm").format("hh:mm A")}
      </div>
    )
  }

  function onBook() {
    const body: any = {
      centerId: eachAppointment?.centerId,
      roomId: selectedRoom?.id,
      bedId: selectedBed,
      appointmentId: eachAppointment?.id,
      patientName: eachAppointment?.patientName,
      patientId: eachAppointment?.patientId,
      bookingDate: eachAppointment?.scheduleDate,
      bookedSlots: selectedSlots,
      primaryConsultantId: eachAppointment?.primaryConsultantId || eachAppointment?.consultantId,
    }
    console.log(body)
    onBedBook(body);
  }
  return (
    <div className="allocation-request-card-wrapper">

      <div className="content card-header">
        <span>Patient Name:</span>
        {PermissionUtils.displayPatientName(
          userRole,
          eachAppointment,
          true,
          null,
          null
        )}
      </div>

      <div className="d-flex content-wrapper align-center">
        {eachAppointment?.appointmentType === "IPD" ? "" :
          <div className="content">
            <span>Consultant Name:</span>
            {eachAppointment?.consultantName}
          </div>
        }
        <div className="content">
          <span>Service:</span>
          {eachAppointment?.serviceName?.length > 0 ? eachAppointment?.serviceName?.join("\n, ") : null}

        </div>
        <div className="content">
          <span>Date:</span>
          {moment(eachAppointment?.scheduleDate).format("DD-MM-YYYY")}
        </div>
        <div className="content">
          <span>Preferred Time:</span>
          {eachAppointment?.bedPreference?.time}
        </div>
        <div className="content">
          <span>Preferred Room:</span>
          {preferredRoomName}
        </div>
        <div className="content">
          <span>Preferred Bed:</span>
          {preferredBedName}
        </div>

        {console.log(eachAppointment?.bedIsVacant, "bedIsVacant")}



        <div className="content">
          <span>Select Room:</span>
          {token ? <Dropdown
            disable
            placeholder="Select Room"
            selected={selectedRoom?.id}
            options={allRooms?.map((each: any) => {
              return { label: each?.name, value: each?.id }
            })}
            updateDropdown={(options: any) => {
              onRoomSelect(options)
            }}
          /> : <Dropdown
            placeholder="Select Room"
            selected={selectedRoom?.id}
            options={allRooms?.map((each: any) => {
              return { label: each?.name, value: each?.id }
            })}
            updateDropdown={(options: any) => {
              onRoomSelect(options)
            }}
          />}


        </div>
        {selectedRoom?.bedDetails &&
          selectedRoom?.bedDetails?.length > 1 && (
            <div className="content">
              {token ? <><span>Select Bed:</span><Dropdown
                placeholder="Select Bed"
                selected={selectedBed}
                disable
                options={selectedRoom?.bedDetails?.map(
                  (each: any) => {
                    return { label: each?.name, value: each?.id };
                  }
                )}
                updateDropdown={(options: any) => {
                  onBedSelect(options);
                }} /></> : <><span>Select Bed:</span><Dropdown
                  placeholder="Select Bed"
                  selected={selectedBed}
                  options={selectedRoom?.bedDetails?.map(
                    (each: any) => {
                      return { label: each?.name, value: each?.id };
                    }
                  )}
                  updateDropdown={(options: any) => {
                    onBedSelect(options);
                  }} /></>}

            </div>
          )}

        {eachAppointment?.allottedBed?.slots?.length > 0 && (<div className="content">
          <span>Booked Slots:</span>
          {eachAppointment?.allottedBed?.slots?.join(", ")}
        </div>)}
      </div>
      <div>
        <div className="d-flex align-center" style={{ paddingTop: "20px" }}>
          <div className="content"> Available Slots: </div>
          <Button
            text="Check for Availability"
            onClick={() => checkAvailability()}
            id="check-for-availability"
          />
        </div>

        <div className="d-flex align-center availability-slots">
          {availableSlots?.length > 0 ? availableSlots?.map((eachSlot: any) =>
            renderSlots(eachSlot)
          ) : <div>No available slots</div>}
        </div>
      </div>
      {enableSlots?.length > 0 ? <div className="content justify-content-end d-flex">
        <Button text="Book bed" onClick={() => onBook()} id="book-bed" />
      </div> : ""}


    </div>
  )
}